import { useInject } from '@back-office/submerchant';
import { GcpFallback } from '@back-office/ui';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const NotFound: FC = () => {
  const { auth } = useInject((store) => store);
  const history = useHistory();
  const { t } = useTranslation();

  const handleOnError = (): void => {
    if (auth.isAuth) {
      history.push('/');
    } else {
      history.push('/login');
    }
  };

  return (
    <GcpFallback
      btn="fallback.home"
      handleOnClick={handleOnError}
      message={t('error.message.invalid_url')}
      title={t('error.title.404')}
    />
  );
};

export default NotFound;
